import { TreePlantedDiv } from "../NftDetails/style";
import {
  AboutBottomMidSection
} from "./style";
import { useNavigate } from "react-router-dom";

const AboutMiddleSection = () => {
  const isMobile = window.innerWidth <= 850;

  return (
    <>
      <AboutBottomMidSection>
        <ul>
          <li>
            <h2>Technology for <br/>tomorrow</h2>
            <h5>Artificial Intelligence beyond the buzz</h5>
            <p>
              Selected initiatives across w2, w3 and w4. 
            </p>
          </li>
          <p>VYGA © is an AI-driven catalyst for global impact. We leverage cutting-edge AI solutions to advance ESG goals, empower governance, and bridge sustainability with equitable growth for all.</p>
        </ul>
      </AboutBottomMidSection>
      {/* <BottomImageSection>
        <div>
          <img src={AboutBottom} alt="img" />
          <h5>
            NFT ART — <span>Photo by bored-ape.com</span>
          </h5>
        </div>
        <BottomImgContent>
          <div>
            <h6>About Mission</h6>
            <h2>VYGA Foundation fosters NFT-driven community empowerment.</h2>
            <p>
              VYGA is reshaping digital communities by using NFTs as a gateway
              to shared ownership and impact. By connecting creators and
              supporters, we foster a collaborative space where members actively
              shape their digital landscape. Join us in building a
              community-driven NFT ecosystem that values creativity and
              connection.
            </p>
            <Button variant="secondary">Explore More</Button>
            <Button variant="secondary">Connect Wallet</Button>
          </div>
        </BottomImgContent>
      </BottomImageSection> */}
    </>
  );
};

export default AboutMiddleSection;
